// src/Pages/Posts/index.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PostCard from '../../components/PostCard';
import './index.css';

const Posts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all'); // all, published, draft

  // 模拟从本地存储或API获取文章数据
  useEffect(() => {
    const fetchPosts = async () => {
      try {
        // 从本地存储获取文章数据
        const storedPosts = localStorage.getItem('blogPosts');
        let postsData = storedPosts ? JSON.parse(storedPosts) : [];

        // 过滤已发布的文章
        if (filter === 'published') {
          postsData = postsData.filter(post => post.status === 'published');
        } else if (filter === 'draft') {
          postsData = postsData.filter(post => post.status === 'draft');
        }

        // 按创建时间排序（最新的在前）
        postsData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        setPosts(postsData);
      } catch (error) {
        console.error('获取文章失败:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, [filter]);

  if (loading) {
    return (
      <div className="posts-container">
        <div className="loading">加载中...</div>
      </div>
    );
  }

  return (
    <div className="posts-container">
      <div className="posts-header">
        <h1>文章</h1>
        <div className="posts-actions">
          <button className="write-new-btn">
            <Link to="/write">写新文章</Link>
          </button>
          <div className="filter-options">
            <button 
              className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
              onClick={() => setFilter('all')}
            >
              全部
            </button>
            <button 
              className={`filter-btn ${filter === 'published' ? 'active' : ''}`}
              onClick={() => setFilter('published')}
            >
              已发布
            </button>
            <button 
              className={`filter-btn ${filter === 'draft' ? 'active' : ''}`}
              onClick={() => setFilter('draft')}
            >
              草稿
            </button>
          </div>
        </div>
      </div>

      {posts.length === 0 ? (
        <div className="no-posts">
          <p>还没有文章，<Link to="/write">写一篇新文章</Link>吧！</p>
        </div>
      ) : (
        <div className="posts-grid">
          {posts.map((post) => (
            <PostCard 
              key={post.id || post.createdAt} 
              post={{
                id: post.id || post.createdAt,
                title: post.title,
                excerpt: post.excerpt || post.content.substring(0, 100) + '...',
                content: post.content,
                date: post.createdAt,
                author: { name: post.author, avatar: '/images/avatar.jpg' },
                categories: post.category ? [post.category] : [],
                tags: post.tags || [],
                likes: post.likeCount || 0,
                comments: post.commentCount || 0,
                image: post.image || null
              }}
              variant="default"
              showAuthor={true}
              showExcerpt={true}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Posts;